import { render, staticRenderFns } from "./CreateBulkShipmentForm.vue?vue&type=template&id=15733ade&scoped=true&"
import script from "./CreateBulkShipmentForm.vue?vue&type=script&lang=ts&"
export * from "./CreateBulkShipmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBulkShipmentForm.vue?vue&type=style&index=0&id=15733ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15733ade",
  null
  
)

export default component.exports